module.exports = __webpack_public_path__ + "img/ic-dollar-square.a21be7f7.svg";